import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SavedViewLimitAlert = ({
  viewCount,
  viewLimit,
  percentOfViewsUsed
}) => {
  const progressBarType = percentOfViewsUsed < 100 ? 'success' : 'danger';
  const alertType = percentOfViewsUsed < 100 ? 'info' : 'warning';
  return /*#__PURE__*/_jsxs(Alert, {
    type: alertType,
    margin: "400",
    "data-test-id": `view-limit-alert-${alertType}`,
    children: [/*#__PURE__*/_jsx(Progress, {
      "data-test-id": "view-limit-progress-bar",
      valueLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.cloneViewModal.viewLimits.alert.progressBar.value",
        options: {
          count: viewCount,
          limit: viewLimit
        }
      }),
      descriptiveLabel: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "viewsManagement.modals.cloneViewModal.viewLimits.alert.progressBar.description"
      }),
      use: progressBarType,
      value: percentOfViewsUsed
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.cloneViewModal.viewLimits.alert.limitInfo"
    })]
  });
};